<div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="background:url(assets/images/big/auth-bg.jpg) no-repeat center center;">
    <div class="auth-box">
        <div id="loginform" [ngClass]="{'d-none': recoverform}">
            <div class="logo">
                <span class="db"><img src="assets/images/netHome/vidaDigital.png" width="100%" height="100%" alt="Tracer" /></span>
            </div>
            <!-- Form -->
            <div class="row">
                <div class="col-12">
                    <form (ngSubmit)="login(loginForm)" #loginForm="ngForm" class="form-horizontal m-t-20" id="loginform">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend-sm">
                                <span class="input-group-text" id="basic-addon1"><i class="fas fa-user"></i></span>
                            </div>
                            <input [ngClass]="{'is-invalid': loginForm.submitted && username.invalid}" autofocus name="username" [(ngModel)]="usuario.username" #username="ngModel" autofocus required minlength="5" type="text" class="form-control form-control-sm" placeholder="Rfc del usuario"
                                aria-label="Username" aria-describedby="basic-addon1">
                            <div class="invalid-feedback" *ngIf="loginForm.submitted && username.invalid && username?.errors.required">
                                <b>El rfc es requerido</b>
                            </div>
                            <div class="invalid-feedback" *ngIf="loginForm.submitted && username.invalid && username?.errors.minlength">
                                <b>El username debe tener al menos 5 caracteres</b>
                            </div>
                        </div>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend-sm">
                                <span class="input-group-text" id="basic-addon2"><i class="fas fa-lock"></i></span>
                            </div>
                            <input [ngClass]="{'is-invalid': loginForm.submitted && password.invalid}" name="password" [(ngModel)]="usuario.password" required #password="ngModel" type="password" class="form-control form-control-sm" placeholder="Password" aria-label="Contraseña"
                                aria-describedby="basic-addon1">
                            <div class="invalid-feedback" *ngIf="loginForm.submitted && username.invalid && username?.errors.required">
                                <b>La contraseña es requerida</b>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-12">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1">
                                    <label class="custom-control-label" for="customCheck1">No cerrar sesión</label>
                                    <a (click)="showRecoverForm()" href="javascript:void(0)" id="to-recover" class="text-success float-right"><i class="p-2 fa fa-lock m-r-5"></i>¿Olvidaste la <b>contraseña?</b></a>
                                </div>
                            </div>
                        </div>
                        <div class="p-3 form-group text-center">
                            <div class="col-xs-12 p-b-20">
                                <button class="btn btn-block btn-lg btn-success" type="submit">Iniciar sesión</button>
                            </div>
                        </div>
                        <!--<div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 m-t-10 text-center">
                                <div class="social">
                                    <a href="javascript:void(0)" class="btn btn-facebook" data-toggle="tooltip" title="" data-original-title="Login with Facebook"> <i aria-hidden="true" class="fab fa-facebook"></i> </a>
                                    <a href="javascript:void(0)" class="btn btn-googleplus" data-toggle="tooltip" title="" data-original-title="Login with Google"> <i aria-hidden="true" class="fab fa-google-plus"></i> </a>
                                </div>
                            </div>
                        </div>-->
                        <div class="form-group m-b-0 m-t-10">
                            <div class="col-sm-12 text-center">
                                ¿No tienes cuenta? Informes en <b>informes@tuvida.digital</b>
                                <!--a (click)="goRegistro()" class="text-success m-l-5"><b>Regístrate</b></a-->
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div id="recoverform" [ngClass]="{'d-block': recoverform}">
            <div class="logo">
                <span class="db"><img src="assets/images/netHome/vidaDigital.png" width="100%" height="100%" alt="Tracer" /></span>
                <h1></h1>
                <h1></h1>
                <h3 class="font-medium m-b-20">Recuperar contraseña</h3>
                <span>¡Ingrese su Rfc y los datos serán enviadas a usted!</span>
            </div>
            <div class="row m-t-20">
                <!-- Form -->
                <form class="col-12">
                    <div class="input-group mb-3">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon3"><i class="ti-user"></i></span>
                            </div>
                            <input type="text" class="form-control form-control-lg" maxlength="13" placeholder="Ingrese el rfc del usuario" value="{{rfcRecuperacion}}" #rfcRecuperado>
                        </div>
                    </div>
                    <div class="row m-t-20">
                        <div class="col-12">
                            <button class="btn btn-block btn-success" (click)="envioDatos(rfcRecuperado.value)" name="action">Recuperar información</button>
                            <button class="btn btn-block btn-success" (click)="toLogin()" name="action">Atrás</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
